import { render, staticRenderFns } from "./ApplicationTemplate.vue?vue&type=template&id=6130d192"
import script from "./ApplicationTemplate.vue?vue&type=script&lang=js"
export * from "./ApplicationTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports